import styled from 'styled-components'
import { DolaThemeProps } from '../../styles/types'

export const StyledSliderCheckbox = styled.label<DolaThemeProps>`
  position: relative;
  display: inline-block;
  width: 55px;
  height: 30px;
  outline: none;

  input {
    position: absolute;
    top: -99999px;
    left: -99999px;
    &:checked + .slider {
      background-color: #00a466;
    }
    &:disabled + .slider {
      background-color: #dddddd;
      cursor: not-allowed;
    }

    &:checked + .slider:before {
      -webkit-transform: translateX(25px);
      -ms-transform: translateX(25px);
      transform: translateX(25px);
    }
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ dolaTheme }) =>
      dolaTheme === 'light' ? '#0B0B0B' : '#333333'};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;
    &:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
    }
  }
`
